import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { border, textPrimary, textSecondary, textMuted, font } from "../../../layouts/schoolPortal/schoolPortalTheme";

/**
 * One shut section of the record, with a sentence that says whether it is
 * worth opening. The record leads with what to do; everything behind it —
 * activity, the exam picture, set work, every topic and answer — waits here
 * until the instructor decides to look. Nothing inside renders (or fetches)
 * until it is opened.
 */
export default function DigIn({ title, summary, defaultOpen = false, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Box sx={{ backgroundColor: "#fff", border: `1px solid ${border}`, borderRadius: "10px", mt: 1, overflow: "hidden" }}>
      <Box onClick={() => setOpen((o) => !o)} sx={{
        display: "grid", gridTemplateColumns: "190px 1fr 20px", alignItems: "center", columnGap: 2,
        px: 2, py: 1.4, cursor: "pointer", "&:hover": { backgroundColor: "#FAF8F5" },
      }}>
        <Typography sx={{ fontFamily: font, fontSize: "13.5px", fontWeight: 700, color: textPrimary }}>{title}</Typography>
        <Typography sx={{ fontFamily: font, fontSize: "12.5px", color: summary ? textSecondary : textMuted }} noWrap>{summary || "…"}</Typography>
        <ExpandMoreIcon sx={{ fontSize: 18, color: textMuted, transform: open ? "rotate(180deg)" : "none", transition: "transform 0.15s" }} />
      </Box>
      {open && <Box sx={{ borderTop: `1px solid ${border}`, px: 2, py: 1.5 }}>{children}</Box>}
    </Box>
  );
}
